// @ts-expect-error untyped import
import MarkdownIt from 'markdown-it';
import { useMemo } from 'react';
import styled, { css } from 'foundations-theming/utils';
import hljs from 'highlight.js/lib/core';
import diffLang from 'highlight.js/lib/languages/diff';
import { jsx as _jsx } from "react/jsx-runtime";
hljs.registerLanguage('diff', diffLang);
function createParser() {
  const md = new MarkdownIt({
    html: false,
    linkify: true,
    breaks: true,
    highlight: (str, lang) => {
      if (lang && hljs.getLanguage(lang)) {
        const highlighted = hljs.highlight(str, {
          language: lang
        }).value;
        return `<pre><code class="hljs">${highlighted}</code></pre>`;
      }
      return '';
    }
  });
  md.disable('lheading');
  const defaultLinkOpen = md.renderer.rules.link_open || ((tokens, idx, options, _env, self) => self.renderToken(tokens, idx, options));
  md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
    const token = tokens[idx];
    token.attrSet('target', '_blank');
    token.attrSet('rel', 'noopener noreferrer');
    return defaultLinkOpen(tokens, idx, options, env, self);
  };
  return md;
}
const parser = createParser();
const MarkdownWrapper = styled.div.withConfig({
  displayName: "MarkdownText__MarkdownWrapper"
})(["", ""], ({
  theme
}) => css(["& p:first-child{margin-block-start:0;}& p:last-child{margin-block-end:0;}& p{margin-block:", ";}& a{color:", ";text-decoration:underline;}& code:not(pre code){background-color:", ";padding:", " ", ";border-radius:", ";font-size:0.875em;}& pre{background-color:", ";border:", " solid ", ";border-radius:", ";padding:", ";overflow-x:auto;}& pre code{background:none;padding:0;font-size:0.875em;}& .hljs-addition{color:#1a7f37;background-color:rgba(63,185,80,0.15);display:inline-block;width:100%;}& .hljs-deletion{color:#cf222e;background-color:rgba(248,81,73,0.15);display:inline-block;width:100%;}& table{width:100%;border-collapse:collapse;margin-block:", ";border:", " solid ", ";display:block;overflow-x:auto;}& thead{background-color:", ";}& th,& td{padding:", ";text-align:left;border:", " solid ", ";}& blockquote{border-inline-start:4px solid ", ";padding-inline-start:", ";margin-block:", ";margin-inline:0;color:", ";}& blockquote p:first-child{margin-block-start:0;}& blockquote p:last-child{margin-block-end:0;}& h1 code:not(pre code),& h2 code:not(pre code),& h3 code:not(pre code),& h4 code:not(pre code),& h5 code:not(pre code),& h6 code:not(pre code){font-size:0.875em;}& ul,& ol{margin-block:", ";padding-inline-start:", ";}& li{margin-block:", ";}& hr{border:none;border-block-start:", " solid ", ";margin-block:", ";}"], theme.space['200'], theme.color['text-interactive-default'], theme.color['fill-surface-recessed'], theme.space['100'], theme.space['200'], theme.borderRadius['100'], theme.color['fill-surface-recessed'], theme.borderWidth['100'], theme.color['border-core-subtle'], theme.borderRadius['200'], theme.space['300'], theme.space['300'], theme.borderWidth['100'], theme.color['border-core-subtle'], theme.color['fill-surface-recessed'], theme.space['200'], theme.borderWidth['100'], theme.color['border-core-subtle'], theme.color['border-core-default'], theme.space['300'], theme.space['200'], theme.color['text-core-subtle'], theme.space['200'], theme.space['400'], theme.space['100'], theme.borderWidth['100'], theme.color['border-core-subtle'], theme.space['300']));
export function MarkdownText({
  text
}) {
  const __html = useMemo(() => {
    if (!text) return '';
    return parser.render(text);
  }, [text]);
  if (!text) {
    return null;
  }
  return /*#__PURE__*/_jsx(MarkdownWrapper, {
    "data-markdown": "true",
    dangerouslySetInnerHTML: {
      __html
    }
  });
}